import { render, staticRenderFns } from "./user_notice.vue?vue&type=template&id=f3abba3c&"
import script from "./user_notice.vue?vue&type=script&lang=js&"
export * from "./user_notice.vue?vue&type=script&lang=js&"
import style0 from "./user_notice.vue?vue&type=style&index=0&id=f3abba3c&prod&lang=css&"


/* normalize component */
import normalizer from "!E:\\vue_project\\nmgkjcx\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports